import { HttpErrorResponse } from '@angular/common/http'
import { API_ERROR_HELPERS, API_ERRORS } from '../constants/api-errors.constants'
import { TapiErrorBody } from '@app/features/oms/models/base-api-response.model'

export class ErrorHandlerHelper {
    static handleHttpError(
        error: HttpErrorResponse | Error,
        customMessages?: Record<number, string>,
    ): string {
        if (error instanceof HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                return API_ERROR_HELPERS.getErrorByStatusCode(0)
            } else {
                const apiErrorMessage = this.extractApiErrorMessage(error.error)
                if (apiErrorMessage) {
                    return apiErrorMessage
                }
                if (customMessages && customMessages[error.status]) {
                    return customMessages[error.status]
                }
                return API_ERROR_HELPERS.getErrorByStatusCode(error.status)
            }
        } else {
            return error.message || API_ERRORS.UNKNOWN_ERROR
        }
    }

    static formatFailureMessageForDialog(
        message: string | undefined,
        defaultMessage: string,
    ): string {
        if (!message || message.trim().length === 0) {
            return defaultMessage
        }

        return message
            .split(';')
            .map((part) => part.trim())
            .filter((part) => part.length > 0)
            .join('<br />')
    }

    /**
     * Extracts error message from API error response body.
     * Checks common fields and supports nested error objects.
     */
    private static extractApiErrorMessage(errorBody: TapiErrorBody): string | null {
        if (!errorBody) return null

        if (typeof errorBody === 'string') return errorBody.trim() || null

        if (typeof errorBody !== 'object' || errorBody === null) return null

        const errorFields: (keyof typeof errorBody)[] = [
            'message',
            'error',
            'detail',
            'errorMessage',
        ]
        for (const field of errorFields) {
            const value = errorBody[field]
            if (typeof value === 'string' && value.trim()) {
                return value.trim()
            }
        }

        return errorBody.error ? this.extractApiErrorMessage(errorBody.error) : null
    }
}
